export const DIALOG_YES = "Yes";
export const DIALOG_NO = "No";
export const DIALOG_OK = "Ok";
export const DIALOG_CANCEL = "Cancel";
export const DIALOG_CLOSE = "Close";
